import { getVerifyAccountCTA } from "./shared";
export var ProvideRequestedInfoIA = function ProvideRequestedInfoIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getVerifyAccountCTA;
        return (_getVerifyAccountCTA = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA === void 0 ? void 0 : _getVerifyAccountCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getVerifyAccountCTA2, _getVerifyAccountCTA3;
        return (_getVerifyAccountCTA2 = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA2 === void 0 ? void 0 : (_getVerifyAccountCTA3 = _getVerifyAccountCTA2.getLink) === null || _getVerifyAccountCTA3 === void 0 ? void 0 : _getVerifyAccountCTA3.call(_getVerifyAccountCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_HAVE_NOT_SUBMITTED(strictLocalize), IF_YOU_HAVE_ALREADY_SUBMITTED(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "zHlNDl",
    defaultMessage: [{
      "type": 0,
      "value": "Partilhar informações para verificar a sua conta"
    }]
  });
};
var IF_YOU_HAVE_NOT_SUBMITTED = function IF_YOU_HAVE_NOT_SUBMITTED(strictLocalize) {
  return strictLocalize({
    id: "V8CNC/",
    defaultMessage: [{
      "type": 0,
      "value": "Se não enviou o formulário de verificação de conta, forneça nele todas as informações necessárias."
    }]
  });
};
var IF_YOU_HAVE_ALREADY_SUBMITTED = function IF_YOU_HAVE_ALREADY_SUBMITTED(strictLocalize) {
  return strictLocalize({
    id: "GHShML",
    defaultMessage: [{
      "type": 0,
      "value": "Se já enviou o formulário, receberá um e-mail assim que analisarmos as suas informações. Habitualmente, respondemos no prazo de 1 dia útil."
    }]
  });
};